import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import ruleSettingsDatasource from '@gameday/core/datasources/ruleSettings';
import scheduleDataSource from '@gameday/core/datasources/schedule';
import changeViewAction from '@gameday/app/lib/store/actions/views';
import { getGameOverState } from '../store/selectors/getGameOverState';
import gameOverDataRequestAction from '../store/actions/gameOverDataRequestAction';
import gameOverReducer from '../store/reducers/gameOver';
import GameOver from '../GameOver';
import Overlay from '../../Overlay/Overlay';
import { routes as teamSummaryRoutes } from '../../TeamSummaryMatchup/TeamSummaryMatchupDataContainer';
import { GAME_OVER } from '../../AtBat/atbat.style';
import { GameOverModelWrapper } from '../../Live/Live.style';
import useGameOverOpen from '../store/hooks/useGameOverOpen';

const fetchData = () => {
    return gameOverDataRequestAction();
};

initContainerData.register({
    datasources: {
        ruleSettings: ruleSettingsDatasource,
        schedule: scheduleDataSource
    },
    reducers: {
        gameOver: gameOverReducer
    }
});

const routes = [{
    path: '/',
    exact: false,
    fetchData,
    routes: [...teamSummaryRoutes]
}];

const GameOverDataContainer = () => {
    const dispatch = useDispatch();
    const gameOverState = useSelector(getGameOverState);
    const { abstractGameCode = '', gameOverScenario: { scenario } } = gameOverState;
    const [gameOverIsOpen, setGameOverIsOpen] = useGameOverOpen(abstractGameCode, scenario);

    const onWrapButtonHandler = useCallback(() => {
        dispatch(changeViewAction({
            game_view: 'final'
        }));
    }, []);

    const onGameOverClose = useCallback(() => {
        setGameOverIsOpen(false);
    }, [setGameOverIsOpen]);

    return (
        !gameOverIsOpen
            ? null
            : <Overlay
                ContentComponent={GameOverModelWrapper}
                isCentered={true}
                isOpen={gameOverIsOpen}
                onClose={onGameOverClose}
                type={GAME_OVER}>
                <GameOver { ...gameOverState } wrapButtonHandler={ onWrapButtonHandler } />
            </Overlay>
    );
};

GameOverDataContainer.propTypes = {};

export default GameOverDataContainer;

export { fetchData, routes };
